import React from 'react';
function EditIcon({ fill = '#5D9CEC', width = 20, height = 20 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20">
            <g fill={fill} fillRule="evenodd">
                <path d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" />
                <path
                    fillRule="nonzero"
                    d="M8.118 14.458a.5.5 0 0 1-.163.11l-2.99 1.23a.417.417 0 0 1-.544-.544l1.231-2.99a.5.5 0 0 1 .11-.163l7.589-7.59a1.667 1.667 0 1 1 2.357 2.358l-.59.59-.589.588-6.41 6.411zm4.643-8.179l-5.893 5.893 1.179 1.18 5.893-5.894L12.76 6.28zm1.179-1.178l-.59.59 1.179 1.178.59-.59a.833.833 0 0 0-1.179-1.178zm-7.611 7.71l-.756 1.836 1.835-.756-1.08-1.08z"
                />
            </g>
        </svg>
    );
}

export default EditIcon;
